import React from "react";
import { ArrowLeft, ArrowRight } from "../icons/arrow-pair-left-right";
import type { TabsSectionType } from "./tabSection.type";

function CarouselArrows({
  tabItems,
  setCurrentTabIndex,
  handleNavigation,
}: {
  tabItems: TabsSectionType["tabItems"];
  setCurrentTabIndex: React.Dispatch<React.SetStateAction<number>>;
  handleNavigation: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  const arrowClass = "w-7 h-7 text-secondary-500";
  const getBtnClass = (position: "left" | "right") =>
    `absolute ${position}-0 top-24 -translate-y-1/2 z-10 md:hidden`;
  return (
    <>
      {/* LEFT ARROW */}
      <button
        onClick={(e) => {
          setCurrentTabIndex((prev) => (prev === 0 ? tabItems.length - 1 : prev - 1));
          handleNavigation(e);
        }}
        className={getBtnClass("left")}
      >
        <ArrowLeft className={arrowClass} />
      </button>
      {/* RIGHT ARROW */}
      <button
        onClick={(e) => {
          setCurrentTabIndex((prev) => (prev + 1) % tabItems.length);
          handleNavigation(e);
        }}
        className={getBtnClass("right")}
      >
        <ArrowRight className={arrowClass} />
      </button>
    </>
  );
}

export default CarouselArrows;
